import { useFrame, useThree } from "@react-three/fiber";
import { useEffect, useRef } from "react";
import * as THREE from 'three';

type BoxHelperProps = {
    selectedUUID: string | null;
};

export const BoxHelper = ({ selectedUUID }: BoxHelperProps) => {
    const { scene } = useThree();
    const selected3DObject = selectedUUID ? scene.getObjectByProperty('uuid', selectedUUID) : null;
    const boxHelperRef = useRef<THREE.BoxHelper>();

    useFrame(() => {
        if (selected3DObject && boxHelperRef.current) boxHelperRef.current.update();
    });

    useEffect(() => {
        if (selected3DObject) {
            boxHelperRef.current = new THREE.BoxHelper(selected3DObject, 'yellow');
            scene.add(boxHelperRef.current);

            return () => {
                if (boxHelperRef.current) scene.remove(boxHelperRef.current);
            };
        }
    }, [scene, selected3DObject]);

    return null;
};